'use es6';

export const getEventSelectorId = id => `marketplace-mirrored__app__${id}`;